import { useParams } from "react-router-dom";
import Dashboard from "screens/components//Dashboard";

function OrganisationOverview() {
    const { organisationId } = useParams();
    return <Dashboard organisationId={organisationId}></Dashboard>
}

export default OrganisationOverview;